import { apiFetch } from '@/api/v2Client';

/**
 * phase-region-format-rules-and-docx-links — per-region document FORMAT
 * rules (SectionFormatRulesCatalog), shown in the admin Submission
 * Requirements tab. Read-only surface; the compiler and the FMT-SLOT-01
 * validator consume the same data server-side through one evaluator.
 */

export type SlotFormat = 'pdf-required' | 'docx-required' | 'pdf-or-docx';

export interface FormatRuleEntry {
  readonly id: string;
  readonly ctdSectionPrefix: string;
  readonly format: SlotFormat;
  readonly notes: string | null;
  readonly isDefault: boolean;
  readonly overridesCatalogId: string | null;
}

export interface FormatRulesResponse {
  readonly region: string;
  readonly defaultFormat: SlotFormat;
  readonly rules: readonly FormatRuleEntry[];
}

export const SLOT_FORMAT_LABELS: Readonly<Record<SlotFormat, string>> = {
  'pdf-required': 'PDF required',
  'docx-required': 'Word (.docx) required',
  'pdf-or-docx': 'PDF or Word',
};

export const formatRulesApi = {
  list(region: string): Promise<FormatRulesResponse> {
    return apiFetch<FormatRulesResponse>(
      `/api/v1/format-rules?region=${encodeURIComponent(region)}`,
    );
  },
};
